/* eslint-disable */
export default {
  matched: 'Correspondências',
  other: 'Outro',
  associated: 'Associado',
  foundFromServer: 'Encontrado a partir de {appName}',
  recently: 'Recentes',
  additionalLabelAccount: 'Conta: {displayName}',
  additionalLabelContact: 'Contacto: {displayName}',
  notFound: 'N/D',
} as const;

// @key: @#@"matched"@#@ @source: @#@"Matched"@#@
// @key: @#@"other"@#@ @source: @#@"Other"@#@
// @key: @#@"associated"@#@ @source: @#@"Associated"@#@
// @key: @#@"foundFromServer"@#@ @source: @#@"Found from {appName}"@#@
// @key: @#@"recently"@#@ @source: @#@"Recent"@#@
// @key: @#@"additionalLabelAccount"@#@ @source: @#@"Account: {displayName}"@#@
// @key: @#@"additionalLabelContact"@#@ @source: @#@"Contact: {displayName}"@#@
// @key: @#@"notFound"@#@ @source: @#@"N/A"@#@
